// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__dgNBC","subheader":"ReorderModal_subheader__2_CHZ","listWrap":"ReorderModal_listWrap__39K8C"};